import { render, staticRenderFns } from "./amDetail.vue?vue&type=template&id=6c556730&scoped=true&"
import script from "./amDetail.vue?vue&type=script&lang=js&"
export * from "./amDetail.vue?vue&type=script&lang=js&"
import style0 from "./amDetail.vue?vue&type=style&index=0&id=6c556730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c556730",
  null
  
)

export default component.exports